var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device === 'mobile')?_c('font-awesome-icon',{attrs:{"icon":"mobile","title":"mobile"}}):(_vm.device === 'api')?_c('font-awesome-icon',{attrs:{"icon":"link","title":"api"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }